module.exports = __webpack_public_path__ + "static/media/my_inspections.bddb8095.svg";